import { IRootState } from '../../../../app/store';

export const selectPendingAssignmentAsyncStatus = (state: IRootState) =>
    state.myLearning.pendingAssignmentAsyncStatus;

export const selectAssignmentDetails = (state: IRootState) => ({
    assignment: state.myLearning.assignment,
    type: state.myLearning.type,
});

export const selectUserAssignmentCoursesAsyncStatus = (state: IRootState) =>
    state.myLearning.userAssignmentCoursesAsyncStatus;

export const selectUserAssignmentCourses = (state: IRootState) =>
    state.myLearning.userAssignmentCourses;
